const settings = {
    APIKey: process.env.REACT_APP_BACKEND_API_KEY !== undefined ? process.env.REACT_APP_BACKEND_API_KEY : null,
    baseURL: process.env.REACT_APP_BACKEND_URL !== undefined ? process.env.REACT_APP_BACKEND_URL : null,
};

if (settings.APIKey === null) {
    settings.APIKey = localStorage.getItem('APIKey') || null
}

if (settings.baseURL === null) {
    settings.baseURL = localStorage.getItem('baseURL') || null
}

if (settings.baseURL === null) {
    if (window.location.hostname.endsWith("vincit.fi")) {
        settings.baseURL = "https://api.test.kuntaliitto.vincit.fi";
    }
    else {
        settings.baseURL = "https://api.nuodo.fi";
    }
}

export default settings;